import FileService from '../../services/file-service';
import FormatService from '../../services/format-service';
import FormService from '../../services/form-service';
import { FILE_EXTENSION_LIST_IMAGE } from '../../constants/system/file-extensions';

const ActivityListValidator: Validator = (values: FormValues): ValidationErrors => {
  const errors: ValidationErrors = {};

  const formKeyNew: string = FormService.getIndexedFormFieldKey(FormService.FORM_KEY_NEW);

  const requiredFields: string[] = [
    'category',
    'status',
    'type',
  ];

  const dealRequiredFields: string[] = [
    'name',
    'assetId',
  ];

  const dealSourceRequiredFields: string[] = [
    'name',
  ];

  const dealContactRequiredFields: string[] = [
    'firstName',
    'lastName',
    'email',
    'groupIds',
  ];

  if (values.activityListData) {
    if (!errors.activityListData) {
      errors.activityListData = {};
    }

    Object.keys(values.activityListData).forEach((activityIndex: string): void => {
      const activityData: ValidationEntityInput = {
        ...values.activityListData[activityIndex],
      };

      if (activityData) {
        if (!errors.activityListData[activityIndex]) {
          errors.activityListData[activityIndex] = {};
        }

        requiredFields.forEach((field: string): void => {
          if (!activityData[field] || !activityData[field].toString().trim()) {
            errors.activityListData[activityIndex][field] = 'Required';
          }
        });

        if (activityData.deal && Object.keys(activityData.deal).length) {
          if (!errors.activityListData[activityIndex].deal) {
            errors.activityListData[activityIndex].deal = {};
          }

          dealRequiredFields.forEach((field: string): void => {
            if (!activityData.deal[field] || !activityData.deal[field].toString().trim()) {
              errors.activityListData[activityIndex].deal[field] = 'Required';
            }
          });

          if (activityData.deal.mainPhoto
            && !FileService.checkFileExtension(activityData.deal.mainPhoto, FILE_EXTENSION_LIST_IMAGE)) {
            errors.activityListData[activityIndex].deal.mainPhoto = 'Incorrect file type';
          }

          if (!Object.keys(errors.activityListData[activityIndex].deal).length) {
            delete errors.activityListData[activityIndex].deal;
          }
        } else if (!activityData.dealId || !activityData.dealId.toString().trim()) {
          errors.activityListData[activityIndex].dealId = 'Required';
        }

        if (activityData.dealSource && Object.keys(activityData.dealSource).length) {
          if (!errors.activityListData[activityIndex].dealSource) {
            errors.activityListData[activityIndex].dealSource = {};
          }

          dealSourceRequiredFields.forEach((field: string): void => {
            if ((!activityData.dealSource[field] || !activityData.dealSource[field].toString().trim())
              && activityData.dealSource[field] !== null) {
              errors.activityListData[activityIndex].dealSource[field] = 'Required';
            }
          });

          if (!Object.keys(errors.activityListData[activityIndex].dealSource).length) {
            delete errors.activityListData[activityIndex].dealSource;
          }
        }

        if (activityData.dealContact && Object.keys(activityData.dealContact).length) {
          if (!errors.activityListData[activityIndex].dealContact) {
            errors.activityListData[activityIndex].dealContact = {};
          }

          dealContactRequiredFields.forEach((field: string): void => {
            if ((!activityData.dealContact[field] || !activityData.dealContact[field].toString().trim())
              && activityData.dealContact[field] !== null) {
              errors.activityListData[activityIndex].dealContact[field] = 'Required';
            }
          });

          if (activityData.dealContact.email && !FormatService.isValidEmail(activityData.dealContact.email)) {
            errors.activityListData[activityIndex].dealContact.email = 'Invalid email address';
          }

          if (activityData.dealContact.phone && !FormatService.isValidPhoneNumber(activityData.dealContact.phone)) {
            errors.activityListData[activityIndex].dealContact.phone = 'Invalid phone number';
          }

          if (!Object.keys(errors.activityListData[activityIndex].dealContact).length
            || (activityData.dealContact.firstName === null && activityData.dealContact.lastName === null)) {
            delete errors.activityListData[activityIndex].dealContact;
          }
        }

        if (errors.activityListData[activityIndex] && (
          !Object.keys(errors.activityListData[activityIndex]).length
          || (activityIndex === formKeyNew && activityData.dealId === null)
        )) {
          delete errors.activityListData[activityIndex];
        }
      }
    });
  }

  if (errors.activityListData && !Object.keys(errors.activityListData).length) {
    delete errors.activityListData;
  }

  return errors;
};

export default ActivityListValidator;
